window.$ = require('jquery');
window.jQuery = window.$;
window._ = require('lodash');

require('bootstrap');
require('admin-lte');
require('select2');

require('parsleyjs');
require('parsleyjs/dist/i18n/es');
require('parsleyjs/dist/i18n/en');

require('flot');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.routes = require('./util/routes');
window.translations = require('./util/translations');
window.translatable_fields = require('./util/translatable_fields');
window.messages = require('./util/messages');
window.datatables = require('./util/datatables');
window.blockui = require('./util/blockui');
window.menu = require('./util/menu');
window.ajax = require('./util/ajax');

window.app = {};
window.app.profile = require('./app/profile');
window.app.admin = {
    kiosks: require('./app/admin/kiosks'),
    users: require('./app/admin/users'),
    logs: require('./app/admin/logs'),
};

window.app.certificate_requests = require('./app/certificate_requests');

window.app.reports = {
    certificate_requests: require('./app/reports/certificate_requests'),
    kiosks_usage: require('./app/reports/kiosks_usage'),
};